module.exports = __webpack_public_path__ + "img/bankTransfer5.e0572659.png";